import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class LoginpagemessagesService {
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common"
  scrollHeight: string = '22em';
  constructor(private httpClient: HttpClient) { }

  getOptionDropdown(length): Array<any> {
    let options = []
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e) => {
      options.push({ 'label': e[0], value: e[0] })
    });
    return options
  }

  gettabledata(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/loginpagemessages/gettabledata`);
  }

  getview(id: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/loginpagemessages/getview/${id}`);
  }

  getCSRFtoken(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/loginpagemessages/getcsrf`);
  }
  modify(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/loginpagemessages/modify`, payload);
  }

  add(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/loginpagemessages/add`, payload);
  }
}
